import { FilterUsers } from 'src/models/filter';

import { Callback } from 'src/util/query/models/Callback';

import { DocumentListCallbackStoreContract } from '../interfaces';

export class GetAllUsersWithAccessToTheModuleForTheUserFilterDocumentListCallBack extends Callback<Array<FilterUsers>> {
	public constructor(private readonly store: DocumentListCallbackStoreContract) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<FilterUsers>): void => {
		this.store.setFilterUsers(successResponse);
	};
}
